"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Share = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "2 2 20 20"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M18,14 C16.8,14 15.734,14.542 15,15.382 L9.909,12.836 C9.967,12.566 10,12.287 10,12 C10,11.713 9.967,11.434 9.909,11.164 L15,8.618 C15.734,9.458 16.8,10 18,10 C20.206,10 22,8.206 22,6 C22,3.794 20.206,2 18,2 C15.794,2 14,3.794 14,6 C14,6.287 14.033,6.566 14.091,6.836 L9,9.382 C8.266,8.542 7.2,8 6,8 C3.794,8 2,9.794 2,12 C2,14.206 3.794,16 6,16 C7.2,16 8.266,15.458 9,14.618 L14.091,17.164 C14.033,17.434 14,17.713 14,18 C14,20.206 15.794,22 18,22 C20.206,22 22,20.206 22,18 C22,15.794 20.206,14 18,14",
  id: "Fill-572",
  fill: "#1973E8"
}));
var _default = exports.default = Share;